import Button from '@pinecast/common/Button';
import {Form} from '@pinecast/common/forms';
import Checkbox from '@pinecast/db-spa/forms/Checkbox';
import TextInput from '@pinecast/db-spa/forms/TextInput';
import {required} from '@pinecast/db-spa/forms/validation';
import {FormattedMessage} from '@pinecast/i18n';

import type {Step} from './DonationPage';
import {useGetSubscriptionCheckoutSession} from './useGetSubscriptionCheckoutSession';

const TipJarRequestLogin = ({
  amount,
  onContinue,
  oneTime,
  slug,
}: {
  amount: number;
  onContinue: (step: Step) => void;
  oneTime: boolean;
  slug: string;
}) => {
  const requestLogin = useGetSubscriptionCheckoutSession();
  return (
    <Form
      initialValues={{receiveUpdates: true}}
      onSubmit={async ({values}: {values: Record<string, any>}) => {
        if (requestLogin.pending) {
          return;
        }
        const result = await requestLogin.action({
          variables: {
            podcastSlug: slug,
            amount,
            email: values.email,
            oneTime,
            receiveUpdates: oneTime ? undefined : !!values.receiveUpdates,
          },
        });
        onContinue(
          result.createSubscriptionCheckoutSession!.nextState.toLowerCase() as Step,
        );
      }}
    >
      <TextInput
        description={
          <FormattedMessage
            description="Copy for the user email"
            defaultMessage="To ensure you can cancel your subscription in the future, we need to verify your email. Where should we send the confirmation link?"
          />
        }
        name="email"
        label={
          <FormattedMessage
            description="Label for the user email"
            defaultMessage="Your email"
          />
        }
        placeholder="me@example.com"
        type="email"
        validate={required}
        validateOn="blur"
      />
      {!oneTime && (
        <Checkbox
          label={
            <FormattedMessage
              description="Checkbox to opt in to email updates from the podcast while subscribing"
              defaultMessage="Email me exclusive updates from this podcast"
            />
          }
          name="receiveUpdates"
        />
      )}
      <Button
        $isPrimary
        type="submit"
        pending={requestLogin.pending}
        style={{marginTop: oneTime ? 0 : 12}}
      >
        <FormattedMessage
          description="Button to verify the user email"
          defaultMessage="Verify email"
        />
      </Button>
    </Form>
  );
};

export default TipJarRequestLogin;
